import { render, staticRenderFns } from "./WaybillSharedIndex.vue?vue&type=template&id=716abff2&"
import script from "./WaybillSharedIndex.vue?vue&type=script&lang=js&"
export * from "./WaybillSharedIndex.vue?vue&type=script&lang=js&"
import style0 from "./WaybillSharedIndex.vue?vue&type=style&index=0&id=716abff2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports